import { Data } from "@angular/router"
import { keyValue } from "./search.model";
import { GenericResponse, IntDropDownItem } from "./genericResponse.model";
import { SimpleResponse } from "./AudioVedioRecorder/genericResponse.model";

export interface EmailTemplateListResponse {
  emailTemplateList: EmailTemplate[]
}

export interface EmailTemplate {
  emailTemplateID: number;
  cLPCompanyID: number;
  cLPUserid: number;
  templateName: string;
  shareable: boolean;
  dtModified: Date;
  dtCreated: Date;
  isUseBee: boolean;
  isUseBeeDisplay: string;
  userLastFirst: string;
  htmlText: string;
  class5CodeID: number;
  isActive: boolean;
  jSONText: string;
}

export interface EmailTemplateLoad {
  emailTemplateID: number;
  cLPCompanyID: number;
  cLPUserid: number;
  templateName: string;
  shareable: boolean;
  dtModified: Date;
  dtCreated: Date;
  isUseBee: boolean;
  userLastFirst: string;
  htmlText: string;
  class5CodeID: number;
  isActive: boolean;
  jSONText: string;
}

export interface MailMergeTemplateListResponse {
  mailMergeTemplateList: MailMergeTemplate[];
}
export interface MailMergeTemplate {
  mailMergeTemplateID: number;
  cLPCompanyID: number;
  cLPUserid: number;
  templateName: string;
  shareable: boolean;
  isShareableTeam: boolean;
  dtModified: Date;
  dtCreated: Date;
  isUseBee: string;
  userLastFirst: string;
  teamCode: number;
  display: string;
  hTMLText: string;
  jSONText: string;
}


export interface EmailSnippet {
  emailSnippetID: number;
  cLPUserID: number;
  snippetTitle: string;
  snippetText: string;
}

export interface EmailDropDownsResponse extends GenericResponse {
  emailTemplates: EmailTemplate[];
  mailMergeTemplates: MailMergeTemplate[];
  emailSnippets: EmailSnippet[];
  userToList: keyValue[];
  userFromList: keyValue[];
  isMultipleFromAddress: boolean; // On client if true then show from dropdown with multiple users.
  contactOwnerTemplateId: number;
}
export interface EmailTemplateResponse extends SimpleResponse {
  emailTemplates: EmailTemplate[];
  users: IntDropDownItem[];
}

export interface EmailSnippetResponse {
  emailSnippet: EmailSnippet;
}
export interface ITeamOfficeCode {
  key: number;
  value: string;
}

export interface EmailTemplateBaseDropdownResponse {
  usage: EmailTemplateBaseUsage[];
  industries: EmailTemplateBaseIndustries[];
  seasonal: EmailTemplateBaseSeasonal[];
}

export interface EmailTemplateBaseUsage {
  usage: string;
}

export interface EmailTemplateBaseIndustries {
  industries: string;
}

export interface EmailTemplateBaseSeasonal {
  seasonal: string;
}

export interface EmailTemplateBase {
  emailTemplateBaseID: number;
  templateName: string;
  hTMLText: any;
  thumbnailURL: string;
  dtCreated: Date;
  jSONText: string;
  isUseBee: boolean;
  tags: string;
  usage: string;
  industries: string;
  isMailMergeTemplate: boolean;
  seasonal: string;
}

export interface EmailTemplateBaseUsageResponse {
  usage: EmailTemplateBaseUsage[];
}

export interface EmailTemplateBaseIndustriesResponse {
  industries: EmailTemplateBaseIndustries[];
}

export interface EmailTemplateBaseSeasonalResponse {
  seasonal: EmailTemplateBaseSeasonal[];
}

export interface TagListResponse {
  tagList: string[];
}
export interface TagList {
  tagName: string;
}

export interface MailTypeResponse {
  mailType: MailType[];
}

export interface MailType {
  mailingTpeCode: number;
  clpCompanyID: number;
  display: string;
  sOrder: number;
}

export interface EmailSnippetListResponse {
  emailSnippetList: EmailSnippet[]
}

export interface SimpleReq {
    messageString: string;
}
